import '../../App.css'
import { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import { hourToSecend } from '../../component/hourToSecend'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChevronDown,
    faClock,
    faLock,
    faPhone,
    faPlus,
    faSave,
    faTimes,
    faTrashAlt,
    faUser,
    faUserEdit,
} from '@fortawesome/free-solid-svg-icons'
import { secendToHour } from '../../component/secendToHour'
import { AppContextMenu } from '../../App'

function UserProfile() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('userProfile')
    }, [])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }
    const [addData, setAddData] = useState({ departmentPosition: [] })

    let navigate = useNavigate()

    const { id } = useParams()

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'full_name':
                setAddData({ ...addData, full_name: e.target.value })
                break
            case 'emergency_number':
                setAddData({ ...addData, emergency_number: e.target.value })
                break
            case 'address':
                setAddData({ ...addData, address: e.target.value })
                break
            case 'phone_number':
                setAddData({ ...addData, phone_number: e.target.value })
                break
            case 'personnel_code':
                setAddData({ ...addData, personnel_code: e.target.value })
                break
            case 'password':
                setAddData({ ...addData, password: e.target.value })
                break

            case 'entitlement_hours':
                const value = hourToSecend(e.target.value)
                setAddData({ ...addData, entitlement_hours: value })
                break
            default:
                return null
        }
    }

    useEffect(() => {
        getUser()
    }, [])

    const getUser = async () => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/user/${user.user.id}`,
            },
            resolve: (res) => {
                let resDataUser = res.data
                resDataUser.departmentPosition =
                    resDataUser.userDepartmentPosition.map((item) => {
                        return {
                            id: Math.floor(Math.random() * 1000000),
                            department_id: item.department.id,
                            department_name: item.department.name,
                            position_id: item.position.id,
                            position_name: item.position.name,
                        }
                    })

                setAddData(resDataUser)

                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerSubmit = async () => {
        setLoading(true)
        let departmentPositionValues = []

        departmentPositionValues = addData.departmentPosition.map((item) => {
            return {
                department_id: item.department_id,
                position_id: item.position_id,
            }
        })
        await RequestQueue.sendRequest({
            config: {
                method: 'patch',
                url: `/user/${user.user.id}`,
                data: {
                    departmentsPositions: departmentPositionValues,
                    full_name: addData.full_name,
                    phone_number: addData.phone_number,
                    password: addData.password,
                    personnel_code: addData.personnel_code,
                    entitlement_hours: addData.entitlement_hours,
                    emergency_number: addData.emergency_number,
                    address: addData.address,
                },
            },
            resolve: (res) => {
                setLoading(false)
                toast.dismiss()
                toast.success('کاربر با موفقیت ویرایش شد', {
                    position: 'bottom-center',
                })
                navigate('/users')
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                })
            },
        })
    }
    const handlerCancel = () => {
        navigate(-1)
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faUserEdit}
                                    className="ml-2"
                                />
                                پروفایل کاربر
                            </h2>
                        </div>

                        {/* Form Content */}
                        <div className="p-6 space-y-6">
                            {/* Full Name */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className="ml-2"
                                    />
                                    نام و نام خانوادگی
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="text"
                                    value={addData.full_name}
                                    onChange={(e) => {
                                        setQueryPropertyAddData('full_name', e)
                                    }}
                                />
                            </div>

                            {/* Phone Number */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faPhone}
                                        className="ml-2"
                                    />
                                    شماره همراه
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="tel"
                                    value={addData.phone_number}
                                    onChange={(e) => {
                                        setQueryPropertyAddData(
                                            'phone_number',
                                            e
                                        )
                                    }}
                                />
                            </div>

                            {/* Password */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faLock}
                                        className="ml-2"
                                    />
                                    رمز عبور
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="text"
                                    value={addData.password}
                                    onChange={(e) => {
                                        setQueryPropertyAddData('password', e)
                                    }}
                                />
                            </div>

                            {/* Entitlement Hours */}
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className="ml-2"
                                    />
                                    مرخصی استحقاقی
                                </label>
                                <input
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                    type="tel"
                                    value={secendToHour(
                                        addData.entitlement_hours
                                    )}
                                    disabled
                                />
                            </div>

                            {/* Optional Fields */}
                            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <h4 className="text-sm font-medium text-gray-700 mb-3">
                                    اطلاعات اختیاری
                                </h4>

                                {/* Personnel Code */}
                                <div className="space-y-2 mb-4">
                                    <label className="block text-sm font-medium text-gray-700">
                                        کد پرسنلی
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        type="text"
                                        value={addData.personnel_code}
                                        disabled
                                    />
                                </div>

                                {/* Emergency Number */}
                                <div className="space-y-2 mb-4">
                                    <label className="block text-sm font-medium text-gray-700">
                                        شماره همراه اضطراری
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        type="tel"
                                        value={addData.emergency_number}
                                        onChange={(e) => {
                                            setQueryPropertyAddData(
                                                'emergency_number',
                                                e
                                            )
                                        }}
                                    />
                                </div>

                                {/* Address */}
                                <div className="space-y-2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        آدرس
                                    </label>
                                    <input
                                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        type="text"
                                        value={addData.address}
                                        onChange={(e) => {
                                            setQueryPropertyAddData(
                                                'address',
                                                e
                                            )
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col">
                                <button
                                    type="button"
                                    onClick={handlerCancel}
                                    className="px-6 py-3 border maxLg:my-2 border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ml-2"
                                    />
                                    انصراف
                                </button>
                                <button
                                    type="button"
                                    onClick={handlerSubmit}
                                    className="px-6 py-3 rounded-xl maxLg:my-2 text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="ml-2"
                                    />
                                    ذخیره تغییرات
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default UserProfile
